import React from 'react';
import { WebinarLink } from './WebinarLink';
export const CallToAction = ({
  openModal
}) => {
  // Replace 'webinar' with WebinarLink component in text
  const replaceWebinarWithLink = text => {
    const parts = text.split(/(\bwebinar\b)/i);
    return parts.map((part, index) => {
      if (part.toLowerCase() === 'webinar') {
        return <WebinarLink key={index} onClick={openModal} data-id="element-42">
            webinar
          </WebinarLink>;
      }
      return part;
    });
  };
  return <section className="mb-10" data-id="element-43">
      <div className="w-full mb-6" data-id="element-44">
        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/2FwYxJVjG6C7aeyL5JTuqC/Scherm_afbeelding_2025-08-15_om_15.56.55-min.png" alt="Vrouw communiceert met haar hond in een gezellige woonkamer" className="w-full h-auto rounded-lg shadow-md hover:opacity-95 transition-opacity cursor-pointer" onClick={openModal} data-id="element-45" />
        <p className="text-xs text-gray-500 mt-1 text-center italic" data-id="element-46">
          Soms kan anderhalf uur alles veranderen in de relatie met je hond
        </p>
      </div>
      <div className="bg-red-50 p-3 rounded-lg mb-6 border-2 border-red-300" data-id="element-47">
        <p className="text-center font-bold text-red-700" data-id="element-48">
          ⚠️ BEPERKTE PLEKKEN ⚠️
        </p>
      </div>
      <div className="bg-gray-50 p-6 rounded-lg mb-8 border border-gray-200 hover:bg-gray-100 transition-colors" data-id="element-49">
        <div className="flex justify-between items-center mb-4" data-id="element-50">
          <div data-id="element-51">
            <h3 className="text-lg font-bold" data-id="element-52">
              Leer vandaag nog "Communiceren met je Hond"
            </h3>
            <p className="text-gray-600 text-sm" data-id="element-53">
              Vandaag en morgen • 10:00. 13:00 of 20:00
            </p>
          </div>
          <div className="text-right" data-id="element-54">
            <span className="text-2xl font-bold text-blue-800" data-id="element-55">GRATIS</span>
            <p className="text-sm text-green-600" data-id="element-56">Geen verborgen kosten</p>
          </div>
        </div>
        <a href="https://stresslessdogs.nl/mcc-gpm-adv2" className="w-full bg-green-600 hover:bg-green-700 text-white font-bold py-4 px-4 rounded-lg transition duration-200 block text-center mb-4 animate-pulse" target="_blank" rel="noopener noreferrer" data-id="element-57">
          JA, IK WIL MIJN HOND EINDELIJK BEGRIJPEN - GRATIS AANMELDEN
        </a>
        <p className="text-center text-sm text-gray-600 mb-2" data-id="element-58">
          In 90 minuten van frustratie naar begrip, van gissen naar weten, van
          reageren naar communiceren
        </p>
        <div className="flex justify-center space-x-2" data-id="element-59">
          <span className="text-yellow-500" data-id="element-60">★★★★★</span>
          <span className="text-sm text-gray-600" data-id="element-61">
            Meer dan 100.000 deelnemers in 2025
          </span>
        </div>
      </div>
      <p className="font-semibold text-blue-800 text-center mb-6" data-id="element-62">
        <a href="https://stresslessdogs.nl/mcc-gpm-adv2" className="hover:underline cursor-pointer" target="_blank" rel="noopener noreferrer" data-id="element-63">
          Want soms kan anderhalf uur alles veranderen.
        </a>
      </p>
    </section>;
};